<template>
  <main>
    <banner :title="getText('projects')"/>

    <section class="pb-20 bg-gray-700">
      <div class="container mx-auto px-4">
        <div class="flex flex-wrap">
          <div class="text-left pt-12 w-full">
            <div class="w-full flex flex-col md:flex-row">
              <div class="w-full md:w-6/12 md:pr-4 md:pt-0 flex flex-col justify-between">
                <div class="flex-1">
                  <h3 class="text-white font-semibold text-2xl pb-4">{{ getText('tv-tower-title') }}</h3>
                  <h4 class="text-white font-semibold text-lg pb-4">{{ getText('project-duties') }}:
                    {{ getText('p-title-6') }}</h4>
                  <p class="text-white pb-4">{{ getText('tv-tower-description') }}</p>
                </div>

                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/tv-tower')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>

                <slider :images="slidesTVTower" :initial-slide="0" class="flex-1"></slider>
              </div>

              <div class="w-full md:w-6/12 md:pl-4 pt-12 md:pt-0 flex flex-col justify-between">
                <div class="flex-1">
                  <h3 class="text-white font-semibold text-2xl pb-4">{{ getText('z-towers-title') }}</h3>
                  <h4 class="text-white font-semibold text-lg pb-4">{{ getText('project-duties') }}:
                    {{ getText('p-title-7') }}</h4>
                  <p class="text-white pb-4">{{ getText('z-towers-short') }}</p>
                </div>

                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/z-towers')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>

                <slider :images="slidesZTowers" :initial-slide="2"></slider>
              </div>
            </div>
          </div>

          <div class="text-left pt-12 w-full">
            <div class="w-full flex flex-col md:flex-row">
              <div class="w-full md:w-6/12 md:pr-4 md:pt-0 flex flex-col justify-between">
                <div class="flex-1">
                  <h3 class="text-white font-semibold text-2xl pb-4">{{ getText('ventspils-title') }}</h3>
                  <h4 class="text-white font-semibold text-lg pb-4 md:w-11/12">{{ getText('project-duties') }}:
                    {{ getText('p-title-2') }}</h4>
                  <p class="text-white pb-4">{{ getText('ventspils-description') }}</p>
                </div>

                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/ventspils')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>

                <div class="flex-1">
                  <slider :images="slidesVentspils" :initial-slide="0"></slider>
                  <p class="text-white pt-2">Foto: A.Mežule</p>
                </div>
              </div>

              <div class="w-full md:w-6/12 md:pl-4 pt-12 md:pt-0 flex flex-col justify-between">
                <div class="flex-1">
                  <h3 class="text-white font-semibold text-2xl pb-4">{{ getText('lldz-title') }}</h3>
                  <h4 class="text-white font-semibold text-lg pb-4 md:w-11/12">{{ getText('project-duties') }}:
                    {{ getText('p-title-8') }}</h4>
                  <p class="text-white pb-4">{{ getText('lldz-description') }}</p>
                </div>

                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/dzintars')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>

                <div class="flex-1">
                  <slider :images="slidesLLD" :initial-slide="0"></slider>
                  <p class="text-white pt-2">Foto: A.Mežule</p>
                </div>
              </div>
            </div>
          </div>

          <div class="text-left pt-12 w-full">
            <div class="w-full flex flex-col md:flex-row">
              <div class="w-full md:w-6/12 md:pr-4 md:pt-0 flex flex-col justify-between">
                <div class="flex-1">
                  <h3 class="text-white font-semibold text-2xl pb-4">{{ getText('lnb-name') }}</h3>
                  <p class="text-white pb-4">{{ getText('lnb-description-more') }}</p>
                </div>

                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/lnb')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>


                <slider :images="slidesLnb" :initial-slide="0" class="flex-1"></slider>
              </div>

              <div class="w-full md:w-6/12 md:pl-4 pt-12 md:pt-0 flex flex-col justify-between">
                <div class="flex-1">
                  <h3 class="text-white font-semibold text-2xl pb-4">{{ getText('p-name-short-9') }}</h3>
                  <p class="text-white pb-4">{{ getText('p-description-9') }}</p>
                </div>

                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/lnb-infrastructure')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>

                <slider :images="slidesLnbInfrastructure" :initial-slide="0" class="flex-1"></slider>
              </div>
            </div>
          </div>

          <div class="text-left pt-12 w-full">
            <div class="w-full flex flex-col md:flex-row">
              <div class="w-full md:w-6/12 md:pr-4 flex flex-col justify-between">
                <div class="flex-1">
                  <router-link :to="this.getRouteUrl('projects/private')"
                               class="text-white font-semibold text-2xl pb-4 underline">
                    {{ getText('private-title') }}
                  </router-link>
                  <p class="text-white pb-4 flex-1 pt-4">{{ getText('private-description') }}</p>
                </div>
                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/private')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>

                <slider :images="slidesPrivate" :initial-slide="0" class="flex-1"></slider>
              </div>

              <div class="w-full md:w-6/12 md:pl-4 pt-8 md:pt-0 flex flex-col justify-between">
                <div class="flex-1">
                  <router-link :to="this.getRouteUrl('projects/proposals')"
                               class="text-white font-semibold text-2xl pb-4 underline">
                    {{ getText('project-proposals') }}
                  </router-link>
                  <p class="text-white pb-4 pt-4">{{ getText('proposals-short-desc') }}</p>
                </div>

                <div class="underline text-white font-semibold pb-4 flex-1">
                  <router-link :to="this.getRouteUrl('projects/proposals')">
                    {{ getText('more-information') }}
                  </router-link>
                </div>

                <slider :images="slidesProposals" :initial-slide="0" class="flex-1"></slider>
              </div>
            </div>
          </div>

          <div class="text-left pt-12 w-full pt-12" v-if="false">
            <div class="flex flex-wrap">
              <div class="pt-8">
                <h3 class="text-white font-semibold text-2xl pb-4">{{ getText('other-projects') }}</h3>
                <div class="pb-2">
                  <i class="fa fa-building text-white" aria-hidden="true"></i>
                  <span class="pl-4 text-white text-base">{{ getText('arhetips-project-1') }}</span>
                </div>
                <div class="pb-2">
                  <i class="fa fa-building text-white" aria-hidden="true"></i>
                  <span class="pl-4 text-white text-base">{{ getText('arhetips-project-2') }}</span>
                </div>
                <div class="pb-2">
                  <i class="fa fa-building text-white" aria-hidden="true"></i>
                  <span class="pl-4 text-white text-base">{{ getText('arhetips-project-3') }}</span>
                </div>
                <div class="pb-2">
                  <i class="fa fa-building text-white" aria-hidden="true"></i>
                  <span class="pl-4 text-white text-base">{{ getText('gsa-project-1') }}</span>
                </div>
                <div class="pb-2">
                  <i class="fa fa-building text-white" aria-hidden="true"></i>
                  <span class="pl-4 text-white text-base">{{ getText('gsa-project-2') }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import {mapGetters} from 'vuex';

import Slider from '../components/Slider.vue';
import Banner from "./Banner";

export default {
  name: "Projects",
  computed: {
    ...mapGetters(['getText', 'getRouteUrl'])
  },
  components: {
    Banner,
    Slider,
  },
  data() {
    return {
      slidesLnb: [
        '/images/lnb/lnb-1.jpg',
        '/images/lnb/lnb-2.jpg',
        '/images/lnb/lnb-6-2.jpg',
        '/images/lnb/lnb-6.jpg',
        '/images/lnb/lnb-7.jpg',
        '/images/lnb/lnb-8.jpg',
      ],
      slidesLnbInfrastructure: [
        '/images/lnb-infrastructure/lnb-3.jpg',
        '/images/lnb-infrastructure/lnb-4.jpg',
        '/images/lnb-infrastructure/lnb-5.jpg',
      ],
      slidesBaku: [
        '/images/baku.jpg',
        '/images/baku-1.jpg',
        '/images/baku-2.jpg',
        '/images/baku-4.jpg',
      ],
      slidesZTowers: [
        '/images/z-towers/z-towers-1.jpg',
        '/images/z-towers/z-towers-2.jpg',
        '/images/z-towers/z-towers-3.jpg',
        '/images/z-towers/z-towers-4.jpg',
      ],
      slidesLLD: [
        '/images/dzintars/dzintars-1.jpg',
        '/images/dzintars/dzintars-3.jpg',
        '/images/dzintars/dzintars-4.jpg',
        '/images/dzintars/dzintars-5.jpg',
        '/images/dzintars/dzintars-8.jpg',
      ],
      slidesVentspils: [
        '/images/ventspils/ventspils-1.jpg',
        '/images/ventspils/ventspils-2.jpg',
        '/images/ventspils/ventspils-3.jpg',
        '/images/ventspils/ventspils-4.jpg',
        '/images/ventspils/ventspils-6.jpg',
        '/images/ventspils/ventspils-7.jpg',
        '/images/ventspils/ventspils-8.jpg',
      ],
      slidesPrivate: [
        '/images/private/darzu/darzu_18_1.jpg',
        '/images/private/darzu/darzu_18_2.jpg',
        '/images/private/darzu/darzu_18_3.jpg',
        '/images/private/darzu/darzu_18_4.jpg',
        '/images/private/52a/52a_1.jpg',
        '/images/private/52a/52a_2.jpg',
        '/images/private/52a/52a_3.jpg',
        '/images/private/52b/52b_1.jpg',
        '/images/private/52b/52b_2.jpg',
      ],
      slidesProposals: [
        '/images/baku/baku (1).jpg',
        '/images/baku/baku (2).jpg',
        '/images/baku/baku (3).jpg',
        '/images/estrade/estrade-1.jpg',
        '/images/estrade/estrade-2.jpg',
        '/images/estrade/estrade-3.jpg',
        '/images/pirags/pirags-1.jpg',
        '/images/pirags/pirags-2.jpg',
      ],
      slidesTVTower: [
        '/images/tv-tower/tv-tower-1.jpg',
        '/images/tv-tower/tv-tower-2.jpg',
        '/images/tv-tower/tv-tower-3.jpg',
        '/images/tv-tower/tv-tower-5.jpg',
        '/images/tv-tower/tv-tower-6.jpg',
        '/images/tv-tower/tv-tower-7.jpg',
        '/images/tv-tower/tv-tower-8.jpg',
        '/images/tv-tower/tv-tower-9.jpg',
        '/images/tv-tower/tv-tower-10.jpg',
        '/images/tv-tower/tv-tower-11.jpg',
      ]
    }

  }
}
</script>